import { MotoboysList } from '@/_features/motoboys/motoboy-list';

function Motoboys() {
  return (
    <div className="container">
      <MotoboysList />
    </div>
  );
}

export default Motoboys;
